<template>
    <div class="page-wrapper survey-page">
        <div class="page-content">
            <TopBarImage :isShowLogo="false"></TopBarImage>
            <div class="page-heaer">
                <img class="back-icon" src="@/assets/icon/survey/ic-back.svg" alt="back-icon"
                    @click="goBack()">
                {{ lbl.survey.header }}
            </div>
            <div class="wrapper-survey">
                <div class="content-container">
                    <div>
                    <div class="header">
                        {{ lbl.survey.title }}
                    </div>
                    <InputDropdown
                        v-model="form_survey.skin_type"
                        :inputLbl="lbl.survey.skin_type"
                        :isFirstSave="isFirstSave"
                        :errorInfo="errorInfo[0]"
                        :isShowErrorLbl="true"
                        :itemList="skinTypeList"
                        :isRequired="true"
                        @input="onFormUpdate($event)"
                    ></InputDropdown>
                    <div class="skin_issues">
                        <div class="title">
                            {{ lbl.survey.skin_issues.title }}
                            <span class="required"> *</span>
                        </div>
                        <div class="list" >
                            <div v-for="(item, key) in skinIssueList" :key="key" class="item"  @click="selectIssue(item)">
                                <img v-if="item.active" src="../../../assets/icon/survey/ic-check.svg" alt="">
                                <img v-else src="../../../assets/icon/survey/ic-uncheck.svg" alt="">
                                <div class="text">{{ item.text }}</div>
                            </div>
                        </div>
                    </div>
                    <InputDropdown
                        v-model="form_survey.products_used"
                        :inputLbl="lbl.survey.products_used"
                        :isFirstSave="isFirstSave"
                        :errorInfo="errorInfo[1]"
                        :isShowErrorLbl="true"
                        :itemList="productsUsedList"
                        :isRequired="true"
                        @input="onSelectProduct()"
                    ></InputDropdown>
                    <TextAreaInput
                        v-if="isShowOtherProductInput"
                        v-model="form_survey.other_product" 
                        inputId="other_product_input"
                        :inputLbl="lbl.survey.other_product"
                        :isFirstSave="isFirstSave"
                        :errorInfo="errorInfo[2]"
                        @input="onFormUpdate()"/>
                    </div>
                    <div class="button-position">
                        <Button
                            btnId="survey"
                            :isBtnDisable="!isFormValid"
                            :btnMsg="lbl.default.confirm"
                            @clickButton="onSubmit()"/>
                    </div>
                </div>
            </div>
        </div>
        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>
<script>
// helper
import Util from '@/helper/Utility';
import FormHelper from '@/helper/FormHelper.js';
import Account from '@/helper/AccountHelper.js';
import CacheHelper from "@/helper/CacheHelper.js";
//component
import TopBarImage from '@/components/Layout/TopbarImage/TopBarImage.vue';
import InputDropdown from '@/components/Input/Dropdown.vue'
import TextAreaInput from '@/components/Input/TextAreaInput.vue'
import Button from '@/components/Button/Button.vue'
import ModalMaster from '@/components/Modal/ModalMaster.vue'
// mixin
import AccountMixin from "@/mixin/AccountMixin.js";
import LocaleMixin from '@/mixin/LocaleMixin';
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
import ModalMixin from '@/mixin/ModalMixin';
// service
import BzbsProfile from '@/core/Account/service/BzbsProfile';
import BzbsAuth from '@/core/Account/service/BzbsAuth';
import BzbsPDPA from '@/core/PDPA/service/BzbsPDPA';
import BzbsCampaign from '@/core/Campaign/service/BzbsCampaign';
// model
import { PDPAModel } from '@/core/PDPA/model/PDPAModel.js';
import { CampaignConfigBuilder } from "@/core/Campaign/model/CampaignConfigModel.js";

export default {
    name: 'SurveyPage',
    mixins: [LocaleMixin, ModalMixin, ErrorApiMixin, AccountMixin],
    components: {
        TopBarImage,
        InputDropdown,
        TextAreaInput,
        Button,
        ModalMaster,
    },
    data: function() {
        return {
            isFirstSave: true,
            isFormValid: false,
            errorInfo: [],
            form_survey: {
                skin_type: '',
                skin_issues: [],
                products_used: '',
            },
            skinTypeList: [
                {text: 'ผิวธรรมดา', value: 'ผิวธรรมดา'},
                {text: 'ผิวแพ้ง่าย', value: 'ผิวแพ้ง่าย'},
                {text: 'ผิวมัน เป็นสิว', value: 'ผิวมัน เป็นสิว'},
                {text: 'ผิวผสม', value: 'ผิวผสม'},
                {text: 'ผิวแห้งขาดน้ำ', value: 'ผิวแห้งขาดน้ำ'},
            ],
            skinIssueList: [
                {text: 'สิว', value: 'สิว', active: false},
                {text: 'ริ้วรอย', value: 'ริ้วรอย', active: false},
                {text: 'ผิวแพ้ง่าย', value: 'ผิวแพ้ง่าย', active: false},
                {text: 'ผิวแห้ง', value: 'ผิวแห้ง', active: false},
                {text: 'ผิวไม่กระชับ หย่อนคล้อย', value: 'ผิวไม่กระชับ หย่อนคล้อย', active: false},
                {text: 'ผิวไม่กระจ่างใส', value: 'ผิวไม่กระจ่างใส', active: false},
            ],
            productsUsedList: [
                {text: 'Bioderma', value: 'Bioderma'},
                {text: 'เคาน์เตอร์แบรนด์', value: 'เคาน์เตอร์แบรนด์'},
                {text: 'เวชสำอาง', value: 'เวชสำอาง'},
                {text: 'แบรนด์อื่นๆ (other)', value: 'แบรนด์อื่นๆ (other)'},
            ],
            isShowOtherProductInput: false,
            other_product: '',
            cache: new CacheHelper('session'),
            formRegister: null,
            otpModel: null,
            otherModel: null,

            welcomePoint: 0,
            registerPoint: 0,
            welcomeCoupon: null,

            isMarketing: {
                email: null,
                line: null,
                notification: null,
                sms: null,
                consentAge: 20
            },

            termsVersion: 1,
            privacyVersion: 1,
            marketingVersion: 1,
            marketingRegister: false,

            idToken: null,
        };
    },
    created: function() {
        this.errorInfo = FormHelper.genErrorInfo(3);
        this.setCacheForm()
        this.initialOtherModal();
    },
    methods: {
        setCacheForm: function(){
            let welcomePoint = this.cache.getCache('welcomePoint');
            if (welcomePoint) this.welcomePoint = welcomePoint;

            let welcomeCoupon = this.cache.getCache('welcomeCoupon');
            if (welcomeCoupon) this.welcomeCoupon = welcomeCoupon;

            let formRegister = this.cache.getCache('form_register');
            if (formRegister) this.formRegister = formRegister;

            let otpModel = this.cache.getCache('otpModel');
            if (otpModel) this.otpModel = otpModel;

            let otherModel = this.cache.getCache('otherModel');
            if (otherModel) {
                this.otherModel = otherModel;
                this.termsVersion = this.otherModel.termAndCondition;
                this.privacyVersion = this.otherModel.dataPrivacy;
            }

            let isMarketing = this.cache.getCache('isMarketing');
            if (isMarketing) this.isMarketing = isMarketing;

            let marketingVersion = this.cache.getCache('marketingVersion');
            if (marketingVersion) this.marketingVersion = marketingVersion;

            this.idToken = this.cache.getCache('LineIdToken');
        },
        goBack() {
            this.$router.back();
        },
        onFormUpdate() {
            let valid = FormHelper.validate(this.errorInfo) && this.isSkinIssueListValid() && this.validateInput();
            this.isFormValid = valid;
        },
        selectIssue(item) {
            item.active = !item.active;
            this.form_survey.skin_issues = this.skinIssueList.filter(item => item.active).map(item => item.value);
            this.onFormUpdate()
        },
        isSkinIssueListValid() {
            return this.skinIssueList.some(item => item.active);
        },
        validateInput() {
            if (this.form_survey.products_used !== 'แบรนด์อื่นๆ (other)') return true;
            return this.form_survey.products_used === 'แบรนด์อื่นๆ (other)' && !Util.isEmptyStr(this.form_survey.other_product);
        },
        onSelectProduct() {
            this.onFormUpdate();
            if (this.form_survey.products_used !== 'แบรนด์อื่นๆ (other)') {
                this.form_survey.other_product = '';
                this.isShowOtherProductInput = false;
            } else {
                this.isShowOtherProductInput = true;
            }
        },
        onSubmit() {
            if (!this.isFormValid) return;
            if (!Util.isEmptyStr(this.form_survey.other_product)) {
                this.form_survey.products_used = this.form_survey.other_product;
            }
            this.registerUser(this.formRegister, this.otpModel, this.otherModel);
        },
        registerUser: function(register, otp, other){
            this.loadingModal.show();
            BzbsProfile.registerLine(register, this.idToken, otp, other).subscribe((res) => {
                console.log("res", res);
                this.loadingModal.hide();
                
                //welcome point
                if(res.buzzebees){  
                    // this.welcomePoint = res.buzzebees.traces[0].Points;
                    // let traces_point = res.buzzebees.traces.filter(o => (o.Points >= 0))[0];
                    let traces_point = res.buzzebees.traces.filter(o => (o.Id.indexOf("BiodermaRegister") >= 0))[0];
                    if(traces_point && traces_point.Points > 0){
                        this.welcomePoint = traces_point.Points;
                    }

                    let traces_coupon = res.buzzebees.traces.filter(o => (o.Id.indexOf("BiodermaRegister_WelcomeGift") >= 0))[0];
                    console.log('traces_coupon', traces_coupon)
                    if(traces_coupon){
                        this.welcomeCoupon = traces_coupon;
                    }
                    
                }

                this.lineLogin();

            },(error) =>{
                this.isRegister = false;
                this.loadingModal.hide();

                if(error.id == 2128){
                     this.alertRegisterModal
                        .setTitle(this.lbl.register.alert.text_title)
                        .setMsg(this.lbl.register.alert.text_msg)
                        .setBtnOk(this.lbl.register.alert.text_try)
                        .show();
                }else{
                    this.errorApi(error);
                }

            });
        },
        lineLogin: function(){
            this.loadingModal.show();
            BzbsAuth.apiLoginLine(this.idToken).subscribe(async(res) => {
                console.log("res lineLogin", res);
                Account.setLogin(res);

                if(res.buzzebees){
                    this.registerPoint = res.buzzebees.traces[0].Points;
                }
                let success = await this.submitConsent();
                if (success) {
                    let formData = {
                        skin_type: this.form_survey.skin_type,
                        skin_issues: this.form_survey.skin_issues,
                        products_used: !Util.isEmptyStr(this.form_survey.other_product) ? this.form_survey.other_product : this.form_survey.products_used,
                    }
            
                    let extendjsonstring = JSON.stringify(formData);
                    this.submitSurvey(extendjsonstring);
                }

            },(err) => {
                this.loadingModal.hide();
                console.log(err.response.data);
                 window.location.replace('/linelogin');
            });
        },
        submitConsent: function(){
            //Save Consent
            this.loadingModal.show();
            let token = this.getToken();
            let consentModel = new PDPAModel();
            var consent = {
                termandcondition: this.termsVersion,
                dataprivacy: this.privacyVersion,
                consentAge: 20,
                email: this.isMarketing.email,
                sms: this.isMarketing.sms,
                notification: this.isMarketing.notification,
                line: this.isMarketing.line,
                marketingOption: this.marketingVersion
            }
            consentModel.setPDPAModel(consent);
            let params = consentModel.getParams();
            return new Promise((resolve) => {
                BzbsPDPA.apiPostConsent(token, params).subscribe(
                    (result) => {
                    console.log('apiPostConsent', result);
                    this.loadingModal.hide();
                    resolve(true);
                },(error) => {
                    this.loadingModal.hide();
                    console.log(error);
                    resolve(false)
                }
            );
            })

        },
        submitSurvey(extendjsonstring) {
            let token = this.getToken();
            this.loadingModal.show();
            return new Promise((resolve) => {
                BzbsProfile.surveyProfile(token, extendjsonstring).subscribe({
                    next: (data) => {
                        console.log('surveyProfile', data);
                        Account.apiGetProfile();
                        //show welcome popup
                        this.showWelcomePopup();
                        this.loadingModal.hide();
                        resolve(data);
                    },
                    error: (err) => {
                        this.loadingModal.hide();
                        console.log(err);
                        resolve(null);
                    },
                })
            })
        },
        showWelcomePopup: function(){
            this.clearCache();
            //show welcome point
                this.welcomePointModal
                    .setRegisterPoint(this.registerPoint)
                    .setMsg(this.welcomePoint)
                    .setTag('welcome-point')
                    .show();

                this.welcomePointModal.onClickOk(async (data) =>{
                    if(data.tag == 'welcome-point'){
                        if(this.welcomeCoupon){
                            let campaignId = this.welcomeCoupon.UserDescription;
                            let couponInfo = JSON.parse(this.welcomeCoupon.CustomInfo);
                            let msg = couponInfo.l_title

                            let campaign = await this.getCampaign(campaignId);
                            let btn = '';
                            let isDisable = false;
                            if(campaign){
                                if(campaign.qty <= 0){
                                    isDisable = true;
                                    btn = couponInfo.l_description_2nd;
                                }else{
                                    btn = couponInfo.l_description;
                                }
                            }

                            this.welcomeCouponModal.clearText()
                                .setMsg(msg)
                                .setBtnOk(btn)
                                .setIsDisable(isDisable)
                                .setTag('welcome-coupon')
                                .show();

                            this.welcomeCouponModal.onClickOk((data) =>{
                                if(data.tag == 'welcome-coupon'){
                                    if(campaign){
                                        if(campaign.qty <= 0){
                                            window.location.replace('/home');
                                        }else{
                                            let cacheCookie = new CacheHelper();
                                            cacheCookie.setCache('isRegisterSurvey', 'register_survey');
                                            window.location.replace(`/reward/${campaignId}`);
                                        }
                                    }
                                }
                            });
                            this.welcomeCouponModal.onClickCancel((data) =>{
                                if(data.tag == 'welcome-coupon'){
                                    window.location.replace('/home');
                                }
                            });
                        }else{
                            window.location.replace('/home');
                        }
                    } else {
                        window.location.replace('/home');
                    }
                })
        },
        getCampaign: function(campaignId){
            return new Promise((resolve) => {
                var token = this.getToken();
                let campaignConfig = new CampaignConfigBuilder()
                    .setCampaignId(campaignId)
                    .create();

                    BzbsCampaign.apiGetCampaignDetail(token, campaignConfig).subscribe((campaign) => {
                        console.log('campaign', campaign);
                        resolve(campaign);
                    }, (err) => {
                        this.errorApi(err);
                    });
            });
           
        },

        clearCache: function() {
            this.cache.removeCache('form_register');
            this.cache.removeCache('otpModel');
            this.cache.removeCache('otherModel');
            this.cache.removeCache('registerOTP');
            this.cache.removeCache('welcomePoint');
            this.cache.removeCache('welcomeCoupon');
            this.cache.removeCache('isMarketing');
            this.cache.removeCache('marketingVersion');
        }
    },
}
</script>
<style lang='scss' scoped>
@import "@/style/base/base.scss";
@import '@/style/input/BaseButton.scss';
@import "../style/survey.scss";
</style>